// React import
import React, { Fragment, useEffect, useState, useCallback } from 'react';
//Material component import
import {Divider } from "@mui/material";
// custom component import
import styles1 from "./DailyProductionInsight.module.css";
import InsightTable from 'Samarth Module/components/table/insightTable';
import {ComposedChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, Label } from 'recharts';
import styles from "Samarth Module/components/barAndLineComboChart/barAndLineComboChart.module.css";
import { CircularProgress } from "@mui/material";

const ChangeoverTimeVisibility = ({ data, loader })=> {
    const [tableData, setTableData] = useState([]);
    const [graphData, setGraphData] = useState([]);
    // API call for get filter details
    const fetchDBData = useCallback((data)=>{
        // const resData =  await getFilterDetails(pageType, 'Detailed view');
        const allKeys = Object.keys(data?.[0]).filter(key => key !== 'date');
        const result = allKeys.map(label => {
            const row = { "Pack": label };
            data.forEach(entry => {
                row[entry.date] = entry[label];
            });
            return row;
        });
        setTableData(result); //for display table data.
        setGraphData(data); // for display graph
    }, []);

    useEffect(() => {
        if(data && data.length){
            fetchDBData(data);
        }
    }, [data]);

    const CustomLegend = (props) => {
        const { payload } = props;
        return (
            <div style={{ display: 'flex', justifyContent: 'left', padding: '10px' }}>
                {payload.map((entry, index) => {
                    const { value, color } = entry;
                    return (
                        <span
                            key={`item-${index}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '4px',
                                padding: '0 10px',
                            }}
                        >
                            <span
                                style={{
                                    backgroundColor: color,
                                    width: '6px',
                                    height: '12px',
                                    display: 'inline-block',
                                    borderRadius: '2px',
                                }}
                            />
                            <span style={{ color: '#4D4D4F' }}>{value}</span>
                        </span>
                    );
                })}
            </div>
        );
    };

    const legendStyle = {
        fontSize: '10px',
        paddingTop: '15px',
        color: '#4D4D4F',
    };

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className={styles.customTooltip}>
                    {payload.map((item, index) => (
                        <p key={index} className={styles.tooltipItem}>
                            <span style={{ fontWeight: 600 }}>{item.name}</span>&nbsp; : &nbsp;
                            {item.value}
                        </p>
                    ))}
                </div>
            );
        }
        return null;
    };
    return (
        loader ?
            <div className={styles1.loaderContainer}><CircularProgress /></div> :
            <Fragment>
                <div className={styles1.graphDiv}>
                    <div className={styles1.planText}><span>Changeover time visibility</span></div>
                    <Divider className={styles1.hr} />
                    {/* Line Graph */}
                    <ComposedChart data={graphData}
                        width={580}
                        height={382}
                        margin={{
                            top: 20,
                            right: 10,
                            bottom: 5,
                            left: 20,
                        }}
                    >
                        <CartesianGrid strokeDasharray="3 3" vertical={false} horizontal={true} />
                        <XAxis dataKey="date" tickLine={false} axisLine={false} className={styles.BarLabel} padding={{ left: 0, right: 0 }} >
                            <Label value="Past 4 Weeks" offset={10} position="bottom" style={{ fill: '#2B2B2B', fontSize: '10px', fontWeight: '500' }} />
                        </XAxis>
                        <YAxis domain={[0, 'auto']} axisLine={false} padding={{ left: 0, right: 0 }}
                            tick={{
                                fontSize: 10,           // <-- Decrease this number for smaller font
                                fill: '#2B2B2B',
                                fontWeight: 400
                            }}
                            label={{
                                value: 'Overall changeover time (minutes)',
                                angle: -90,
                                position: 'left',
                                offset: 10,
                                style: {
                                    fill: '#2B2B2B',
                                    fontSize: '10px',
                                    fontWeight: '500',
                                    textAnchor: 'middle',
                                },
                            }}
                        />
                        <Tooltip
                            content={<CustomTooltip />}
                            wrapperStyle={{
                                fontSize: '12px',
                                padding: '6px',
                            }}
                        />
                        <Legend verticalAlign="bottom" align="left" wrapperStyle={legendStyle} content={<CustomLegend />} />

                        <Line type="monotone" dataKey="System plan (S1)" name="System plan (S1)" stroke="#FFC000" fill="#FFC000" strokeWidth={1} />
                        <Line type="monotone" dataKey="MM plan (M1)" name="MM plan (M1)" stroke="#00B190" fill="#00B190" strokeWidth={1} />
                    </ComposedChart>
                    {/* Table */}
                    <InsightTable data={tableData} />
                </div>
            </Fragment>
    );
    
}

export default ChangeoverTimeVisibility;